import { render, staticRenderFns } from "./ConfirmDialog.vue?vue&type=template&id=64ddf978"
import script from "./ConfirmDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3507784597/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64ddf978')) {
      api.createRecord('64ddf978', component.options)
    } else {
      api.reload('64ddf978', component.options)
    }
    module.hot.accept("./ConfirmDialog.vue?vue&type=template&id=64ddf978", function () {
      api.rerender('64ddf978', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/ConfirmDialog.vue"
export default component.exports